import(/* webpackMode: "eager" */ "/vercel/path0/app/profile/inquiries/page.tsx");
